import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset } from 'redux-form';
import Notes from './Notes';
import { IApplicationState } from 'ducks/reducers';
import { actions as uiActions } from 'ducks/ui';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty('CreditNotesForm')(state),
  values: getFormValues('CreditNotesForm')(state),
  isValid: isValid('CreditNotesForm')(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('CreditNotesForm'),
    changeConfirmationDialog: uiActions.changeConfirmationDialog,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
